import { Alert, Typography } from '@mui/material';
import React, { useMemo } from 'react';

const TimeOffAlert = ({ franchise }) => {

  const replyToEmail = useMemo(() => {
    return franchise?.settings?.coachReplyToAddress ? franchise?.settings?.coachReplyToAddress : franchise?.contactEmail;
  },[franchise]);

  const replyToPhone = useMemo(() => {
      return franchise?.coachPortalPhone ? franchise?.coachPortalPhone : franchise?.contactPhone;
  },[franchise]);

  return (
    <Alert severity="info">
      <Typography variant="body1">
     To request time off, please contact your manager at <a  href={replyToEmail? `mailto:${replyToEmail}`:''}>{replyToEmail }</a> or <a href={replyToPhone? `tel:${replyToPhone}`:''}>{replyToPhone}</a>
      </Typography>
    </Alert>
  );
};

export default TimeOffAlert;